export const authMessagesStrings = {
    SIGNUP_SUCCESS:
        "You signed up successfully. Your account will be actived by the WAVE team.",
    RECOVER_SUCCESS:
        "Password Recovery initialized with success. Please verify your e-mail inbox for more instructions.",
    NEW_PASSWORD_SUCCESS:
        "Your password was redefined. Please try to login again.",
    CHANGE_USER_STATUS_SUCCESS: "Changed user status successfully.",
    EDIT_USER_SUCCESS: "User edited successfully.",
    CREATE_USER_SUCCESS: "User created successfully.",
    CREATE_ROLE_SUCCESS: "Role created successfully.",
    DELETE_ROLE_SUCCESS: "Role deleted successfully.",
    EDIT_ROLE_SUCCESS: "Role edited successfully.",
    ADD_USER_TO_ROLE_SUCCESS: "User added with success.",
    DELETE_USER_IN_ROLE_SUCCESS: "User successfully removed.",
    EDIT_USER_PASSWORD_SUCCESS: "Changed Password with success."
};
